import * as React from "react";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

type AvailabilityTitleProps = {
  name: string;
  color: any;
};

export default function AvailabilityTitle({
  name,
  color
}: AvailabilityTitleProps) {
  return (
    <ListItem
      sx={{
        bgcolor: color[200],
        borderLeftColor: color[700],
        borderLeftWidth: 3,
        borderLeftStyle: "solid",
        minWidth: "max-content",
        width: "auto"
      }}
      data-testid="availability-title"
      disableGutters
    >
      <ListItemText primaryTypographyProps={{ fontWeight: 700 }} sx={{ ml: 2 }}>
        {name}
      </ListItemText>
    </ListItem>
  );
}
